import {
  Box,
  Grid,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";


const ReceiptsSkeleton = () => {
  const tableHeadings = {
    company: "Company",
    date: "Date",
    receipt_number: "Receipt Number",
    receipt_amount: "Receipt Amount",
    receipt_status: "Receipt Status",
    fme: "FME",
    fme_income: "FME Income",
    policy_fme_income: "Policy FME Income",
    manual_fme_income: "Manual FME Income",
    covered: "% Covered",
    account: "Account",
    brands: "Brands",
  };

  const headCells = Object.entries(tableHeadings);
  const rows = Array.from(new Array(5)); // Create 5 skeleton rows


  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200],
      ...theme.applyStyles("dark", {
        backgroundColor: theme.palette.grey[800],
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: "#43A047",
      ...theme.applyStyles("dark", {
        backgroundColor: "#43A047",
      }),
    },
  }));

  return (
    <>
      <Box sx={{ padding: "16px" }}>
        <Grid container rowSpacing={2} columnSpacing={2} mb={2}>
          <Grid item xs={9}>
            <Skeleton variant="text" width={200} height={32} sx={{ mb: 1 }} />
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rectangular" width={100} height={36} />
              <Skeleton variant="rectangular" width={100} height={36} />
              <Skeleton variant="rectangular" width={130} height={36} />
            </Stack>
          </Grid>
          <Grid item xs={3}>
            <Box
              border={1}
              borderColor={"rgba(0, 0, 0, 0.12)"}
              borderRadius={2}
              padding={1}
              maxWidth={300}
              ml={"auto"}
            >
              <Box display={"flex"} justifyContent={"space-between"} mb={1}>
                <Skeleton variant="text" width={100} height={20} />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
              <BorderLinearProgress variant="indeterminate" />
            </Box>
          </Grid>
        </Grid>
        <Grid container rowSpacing={2} columnSpacing={3} alignItems={"center"}>
          <Grid item xs={3}>
            <Skeleton variant="rectangular" width="100%" height={40} />
          </Grid>
          <Grid item xs={7}>
            <Skeleton variant="text" width={250} height={26} />
          </Grid>
          <Grid item xs={2}>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="circular" width={40} height={40} />
            </Stack>
          </Grid>
        </Grid>
      </Box>
      <TableContainer className="receiptsTable receiptsMainTable">
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    {value}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell align="center" sx={{ textAlign: "center" }}>
                <TableSortLabel>Quick Actions</TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((_, index) => (
              <TableRow
                key={index}
                sx={{
                  "& > *": {
                    borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
                  },
                }}
              >
                {headCells.map((_, cellIndex) => (
                  <TableCell key={cellIndex} align="left">
                    <Skeleton variant="text" width="80%" />
                  </TableCell>
                ))}
                <TableCell align="center">
                  <Skeleton variant="rectangular" width={100} height={30} sx={{ margin: 'auto', borderRadius: 1 }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ReceiptsSkeleton;
